const ANALYTICS_DATA_ATTR = 'data-analytics-id'

/**
 * Build analytics data attribute props for components in a consistent way.
 * Use this to attach a stable `data-analytics-id` to interactive elements for tracking.
 *
 * @param analyticsId Optional analytics identifier.
 * @returns An object with `{ data-analytics-id: analyticsId }` when a non-empty ID is provided; otherwise `{}`.
 */
export function getAnalyticsDataAttrs(
  analyticsId?: string
): Record<string, string> {
  if (!analyticsId) {
    return {}
  }
  return { [ANALYTICS_DATA_ATTR]: analyticsId }
}
